import { cdRelatorioDeContratosPorNuLinha } from "./contract-report-options";

export const stripContractReportInitialValues = {
  cdTipoRelatorioContratos: cdRelatorioDeContratosPorNuLinha,
  empresas: [],
  linhas: [],
  dtVigencia: { dtInicio: '', dtFim: '' },
  dtCadastro: { dtInicio: '', dtFim: '' },
  dtVencimento: { dtInicio: '', dtFim: '' },
  nuDocumento: '',
  orgaos: [],
  tiposContrato: [],
  tiposServico: [],
  situacaoLinha: 1
};
